<template>
  <el-button :type="type" :plain="plain" :round="round" :size="size" :disabled="disable">
    <el-icon v-if="icon" style="vertical-align: middle;">
      <ElIcons :name="icon" :size="iconSize"/>
    </el-icon>
    <span style="vertical-align: middle;"><slot></slot></span>
  </el-button>
</template>

<script>
export default {
  name: "ElButtons",
  props: {
    size: {
      type: String,
      default: 'default'
    },
    type: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: "",
    },
    plain: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
